import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { QuizData } from '../QuizData';
import { CookieService } from 'ngx-cookie-service';
import { UserData } from 'src/app/model/UserData';

@Component({
  selector: 'app-lifestylequiz',
  templateUrl: './lifestylequiz.component.html',
  styleUrls: ['./lifestylequiz.component.css']
})
export class LifestylequizComponent {
  
  lifestylequizForm : FormGroup;
  @Output() doneSubmiting = new EventEmitter();
  failedMessage : string;
  loggingchallenges = [];
  freetimes = [];
  favoriteexercises = [];
  overeattrigs = [];
  activityPlanSaved : boolean;
  submitted = false;
  successMessage: string;
  activityFailed: boolean;
  reasonstress = [];
  dealstress = [];
  quizDone: boolean;
  


  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,
    private cookie: CookieService,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit(): void {
    let regexPatterns = {
   };
    this.lifestylequizForm  =  this.formBuilder.group({
      loggingchallenges: new FormArray([], minSelectedCheckboxes(1)),
      //freetimes: new FormArray([], minSelectedCheckboxes(3)),
      //favoriteexercises: new FormArray([], minSelectedCheckboxes(1)),
      //overeattrigs: new FormArray([], minSelectedCheckboxes(1)),
      lvlstress: ['', Validators.required],
      hoursSleep: ['', Validators.required],
      //qualitySleep: ['', Validators.required],
      exerciseMore30: ['', Validators.required],
      maritalStatus: ['', Validators.required],
      //reasonstress: new FormArray([], minSelectedCheckboxes(1)),
      //dealstress: new FormArray([], minSelectedCheckboxes(1)),
      smoke: ['', Validators.required],
      //enjoywork: ['', Validators.required],
      //dailysleep: ['', Validators.required],
      //weeklyexercise: ['', Validators.required],
      //stayuplate: ['', Validators.required],
      //worklong: ['', Validators.required],
      //watchplaybrowse: ['', Validators.required],
      //socialsupport: ['', Validators.required],

    });

    this.loggingchallenges = this.getLoggingchallenges();
    this.addLoggingchallengesCheckboxes();

    /*

    this.freetimes = this.getFreetimes();
    this.addFreetimesCheckboxes();

    this.favoriteexercises = this.getFavoriteexercises();
    this.addFavoriteexercisesCheckboxes();

    this.overeattrigs = this.getOvereattrigs();
    this.addOvereattrigsCheckboxes();

    this.reasonstress = this.getReasonstress();
    this.addReasonstressCheckboxes();

    this.dealstress = this.getDealstress();
    this.addDealstressCheckboxes();
    */

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });
  }

  private addLoggingchallengesCheckboxes() {
    this.loggingchallenges.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.lifestylequizForm.controls.loggingchallenges as FormArray).push(control);
    });
  }

  /*
  private addFreetimesCheckboxes() {
    this.freetimes.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.lifestylequizForm.controls.freetimes as FormArray).push(control);
    });
  }

  private addFavoriteexercisesCheckboxes() {
    this.favoriteexercises.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.lifestylequizForm.controls.favoriteexercises as FormArray).push(control);
    });
  }

  private addOvereattrigsCheckboxes() {
    this.overeattrigs.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.lifestylequizForm.controls.overeattrigs as FormArray).push(control);
    });
  }

  private addReasonstressCheckboxes() {
    this.reasonstress.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.lifestylequizForm.controls.reasonstress as FormArray).push(control);
    });
  }

  private addDealstressCheckboxes() {
    this.dealstress.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.lifestylequizForm.controls.dealstress as FormArray).push(control);
    });
  }
  */

  get fmBuilder() { return this.lifestylequizForm.controls; }


  getFormControl(name:any) {
    return this.lifestylequizForm.get(name);
  }
  get formLoggingchallenge() { return <FormArray>this.lifestylequizForm.get('loggingchallenges');}
  get formFreetime() { return <FormArray>this.lifestylequizForm.get('freetimes');}
  get formFavoriteexerice() { return <FormArray>this.lifestylequizForm.get('favoriteexercises');}
  get formOvereattrig() { return <FormArray>this.lifestylequizForm.get('overeattrigs');}
  get formReasonstres() { return <FormArray>this.lifestylequizForm.get('reasonstress');}
  get formDealstres() { return <FormArray>this.lifestylequizForm.get('dealstress');}

  getLoggingchallenges(){
    return [
      { value: 1, id: 'physicalDisability', name: 'Yes, physical disability' },
      { value: 2, id: 'LearningDisability', name: 'Yes, learning disability' },
      { value: 3, id: 'No', name: 'No disability' }
    ];
  }

  getFreetimes() {
    return [
      { id: 'TV', name: 'Watch T.V.' },
      { id: 'Socializing', name: 'Socialize' },
      { id: 'Internet', name: 'Browse the internet' },
      { id: 'Exercising', name: 'Exercise' },
      { id: 'Cooking', name: 'Cook' },
      { id: 'Reading', name: 'Read' },
      { id: 'Familytime', name: 'Spend time with family' },
      { id: 'Sports', name: 'Sports' },
      
    ];
  }

  getFavoriteexercises() {
    return [
      { id: 'Walking', name: 'Walking' },
      { id: 'Running', name: 'Running' },
      { id: 'Biking', name: 'Biking' },
      { id: 'Swimming', name: 'Swimming' },
      { id: 'Sports', name: 'Ball Sports' },
      { id: 'Dancing', name: 'Dancing' },
      { id: 'Gym', name: 'Weight Lifting/Gym' },
      { id: 'Gardening', name: 'Gardening' },
    ];
  }

  getOvereattrigs() {
    return [
      { id: 'Stressed', name: 'Yes, when I am stressed' },
      { id: 'PastBedtime', name: 'Yes, when I stay up past my bedtime' },
      { id: 'TV', name: 'Yes, when I am watching T.V.' },
      { id: 'EatOut', name: 'Yes, when I eat out' },
      { id: 'SnacksParty', name: 'Yes, when there are free snacks' },
      { id: 'Other', name: 'Other' },
      { id: 'No', name: 'No, I have no triggers' },
    ];
  }

  getReasonstress() {
    return [
      { id: 'Finance', name: 'Finance' },
      { id: 'Family', name: 'Family' },
      { id: 'Health', name: 'Health' },
      { id: 'Work', name: 'Work' },
      { id: 'Marriage', name: 'Marriage' },
      { id: 'UnfulfilledExpectations', name: 'Unfulfilled Expectations' },
    ];
  }

  getDealstress() {
    return [
      { id: 'SmokeDrink', name: 'Smoke or Drink' },
      { id: 'Exercise', name: 'Exercise' },
      { id: 'Eat', name: 'Eat' },
      { id: 'Talk', name: 'Talk it out' },
      { id: 'Medicine', name: 'Medicine' },
      { id: 'Nothin', name: 'Do nothing' },
    ];
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.lifestylequizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.lifestylequizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }


  submitClick(){

    if (this.lifestylequizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
    this.submitted = true;
    const selectedLoggingchallenges = this.lifestylequizForm.value.loggingchallenges
      .map((v, i) => v ? this.loggingchallenges[i].value : null)
      .filter(v => v !== null);
/*
    const selectedFreetimes = this.lifestylequizForm.value.freetimes
      .map((v, i) => v ? this.freetimes[i].id : null)
      .filter(v => v !== null);

    const selectedFavoriteexercises = this.lifestylequizForm.value.favoriteexercises
      .map((v, i) => v ? this.favoriteexercises[i].id : null)
      .filter(v => v !== null);

    const selectedOvereattrigs = this.lifestylequizForm.value.overeattrigs
      .map((v, i) => v ? this.overeattrigs[i].id : null)
      .filter(v => v !== null);

    const selectedReasonstress = this.lifestylequizForm.value.reasonstress
      .map((v, i) => v ? this.reasonstress[i].id : null)
      .filter(v => v !== null);

    const selectedDealstress = this.lifestylequizForm.value.dealstress
      .map((v, i) => v ? this.dealstress[i].id : null)
      .filter(v => v !== null);

*/
    
    
    var lifestyleQuizData = new QuizData();
    lifestyleQuizData.loggingchallenges= selectedLoggingchallenges;
    /*
    lifestyleQuizData.freetimes = selectedFreetimes;
    lifestyleQuizData.favoriteexercises = selectedFavoriteexercises;
    lifestyleQuizData.overeattrigs = selectedOvereattrigs;
    */
    lifestyleQuizData.lvlstress= String(this.lifestylequizForm.get(['lvlstress']).value);
    /*
    lifestyleQuizData.reasonstress= selectedReasonstress;
    lifestyleQuizData.dealstress= selectedDealstress;
    */
    lifestyleQuizData.smoke= String(this.lifestylequizForm.get(['smoke']).value);
    lifestyleQuizData.hoursSleep= String(this.lifestylequizForm.get(['hoursSleep']).value);
    //lifestyleQuizData.qualitySleep= String(this.lifestylequizForm.get(['qualitySleep']).value);
    lifestyleQuizData.exerciseMore30= String(this.lifestylequizForm.get(['exerciseMore30']).value);
    /*
    lifestyleQuizData.enjoywork= String(this.lifestylequizForm.get(['enjoywork']).value);
    lifestyleQuizData.dailysleep= String(this.lifestylequizForm.get(['dailysleep']).value);
    lifestyleQuizData.weeklyexercise= String(this.lifestylequizForm.get(['weeklyexercise']).value);
    lifestyleQuizData.stayuplate= String(this.lifestylequizForm.get(['stayuplate']).value);
    lifestyleQuizData.worklong= String(this.lifestylequizForm.get(['worklong']).value);
    lifestyleQuizData.watchplaybrowse= String(this.lifestylequizForm.get(['watchplaybrowse']).value);
    lifestyleQuizData.socialsupport= String(this.lifestylequizForm.get(['socialsupport']).value);
    */
    lifestyleQuizData.maritalStatus= String(this.lifestylequizForm.get(['maritalStatus']).value);
  

    this._bkoffService.setlifestylequiz(lifestyleQuizData).then((success)=>{
      this.doneSubmiting.emit("saved")
      this.cookie.set("lifestyleDone", "true");
      this.activityPlanSaved = true;
      this.router.navigateByUrl('/quiz4');
      /*
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'Your Lifestyle has been stored';
      modalRef.componentInstance.title = 'Success';
      */
      this._bkoffService.setisLifestyleDone();
    }).catch(()=>{
     this.failedMessage  = "Error saving Lifestyle Quiz "
     this.activityFailed = true
     this.sendUserFeedback(this.failedMessage)
     this.doneSubmiting.emit("failed")
     console.log(this.failedMessage)
    });
  }

  sendUserFeedback(message:string){
    
    const modalRef = this.modalService.open(NgbdModalContent);
    if (!this.activityPlanSaved){
      modalRef.componentInstance.name = 'Error saving data , please try again';
    }
   
  }

}

function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}


